export const backflowJobItemRequiredFields = [
  { key: 'asset_no', label: 'Asset No' },
  { key: 'backflow_type', label: 'Equipment Type' },
  { key: 'bfp_manufacturer_id', label: 'Make' },
  { key: 'location', label: 'Location' },
  { key: 'model_no', label: 'Model No' },
  { key: 'serial_no', label: 'Serial No' },
  { key: 'wm_manufacturer_id', label: 'Water Meter Make' },
  { key: 'water_meter_serial', label: 'Water Meter Brass Body Serial #' },
];

export const backflowLogRequiredFields = (backflow_type) => {
  const baseFields = [
    { key: 'backflow_size', label: 'Backflow Size' },
    { key: 'line_pressure_psi', label: 'Line Pressure PSI' },
    { key: 'test1_gauge_value', label: '#1 Gauge value' },
    { key: 'test1_valve_tight', label: '#1 Check valve tight' },
    { key: 'test2_gauge_value', label: '#2 Gauge value' },
    { key: 'test2_valve_tight', label: '#2 Check valve tight' },
    { key: 'pass_or_fail', label: 'Pass or Fail' },
  ];

  if (backflow_type === 'Backflow Preventer') {
    baseFields.push(
      { key: 'test3_relief_valve_pressure', label: '#3 Relief Valve Pressure' },
      { key: 'test3_valve_open', label: '#3 Valve Open' },
    );
  }

  return baseFields;
};
